
import {computed, ref} from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const toast = useToast();
    const appMenu = computed(() => {
      const menu = ref([
        // {
        //   label:'Gởi tin nhắn',
        //   icon:'pi pi-fw pi-send',
        //   to: '/sendmessage'
        // },
        // {
        //   label:'Đăng hình ảnh',
        //   icon:'pi pi-fw pi-upload',
        //   to: '/uploadImage'
        // },
        // {
        //   label:'Nhân viên nhận báo cáo',
        //   icon:'pi pi-fw pi-bars',
        //   to: '/addReceiverReportPage'
        // },
        // {
        //   label:'Nhân viên nhận thông báo CK',
        //   icon:'pi pi-fw pi-dollar',
        //   to: '/addAccountantPage'
        // },
        // {
        //   label:'Nhân viên nhận thông báo BN té/ngã',
        //   icon:'pi pi-fw pi-megaphone',
        //   to: '/addReceiverFallPage'
        // },
        // {
        //   label:'Thêm nhóm',
        //   icon:'pi pi-fw pi-plus-circle',
        //   to: '/addGroup'
        // },
        // {
        //   label:'Danh sách đăng ký khám bệnh',
        //   icon:'pi pi-fw pi-list',
        //   to: '/listRegisterService'
        // },
        // {
        //   label:'Thêm nhân viên hỗ trợ',
        //   icon:'pi pi-fw pi-user-plus',
        //   to: '/addemployee'
        // },
        // {
        //   label:'Danh sách nhân viên',
        //   icon:'pi pi-fw pi-users',
        //   to: '/showlistemployee'
        // },
        // {
        //   label:'Quản lý nhóm',
        //   icon:'pi pi-fw pi-users',
        //   to: '/managergroup'
        // },
        // {
        //   label:'Quản lý nghỉ phép',
        //   icon:'pi pi-fw pi-list',
        //   to: '/showlistdayoff'
        // }
      ]);
      const menuDefault = ref([
      ]);
      if(!!store.state.token)
        return menu.value;
      else
        return menuDefault.value;
    });
    const logout = () => {
      store.dispatch('clearToken');
      store.dispatch('clearPermission');
      router.push({
        name: 'login',
      });
      toast.add({
        severity:'success',
        summary: 'Đăng xuất',
        detail:'Đã xóa thông tin đăng nhập thành công',
        life: 1000
      });
    }
    const gotoLoginPage = () => {
      router.push({
        name: 'login',
      });
    }

    return {
      appMenu,
      logout,
      gotoLoginPage
    }
  }
}
